import { render, staticRenderFns } from "./ConcludedOffBoarding.vue?vue&type=template&id=038821f0&scoped=true"
import script from "./ConcludedOffBoarding.vue?vue&type=script&lang=js"
export * from "./ConcludedOffBoarding.vue?vue&type=script&lang=js"
import style0 from "./ConcludedOffBoarding.vue?vue&type=style&index=0&id=038821f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038821f0",
  null
  
)

export default component.exports